import { twMerge } from 'tailwind-merge';

interface PdfSectionHeadingProps {
  text: string;
  subText?: string;
  containerClassName?: string;
  icon: React.ReactNode;
  textClassName?: string;
}

export const PdfSectionHeading = ({
  text,
  subText,
  icon,
  containerClassName,
  textClassName,
}: PdfSectionHeadingProps) => {
  return (
    <div className={twMerge('flex items-center', containerClassName)}>
      <div className="flex items-center gap-2">
        <div className="-mt-0.5 flex items-center">{icon}</div>
        <h2
          className={twMerge(
            'flex items-center text-[19px] font-medium',
            textClassName
          )}
        >
          {text}
        </h2>
      </div>
      {subText && (
        <div className="ml-5 flex items-center gap-1.5">
          <div className="text-black text-xs font-medium">|</div>
          <div className="text-sm font-medium">{subText}</div>
        </div>
      )}
    </div>
  );
};
